module.exports = __webpack_public_path__ + "img/large4.b07be8f4.jpg";